import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

export const tesla = createAsyncThunk(
    'tesla/getTesla',
    async () => {
        try {
            const request = await axios.get("api/sensor/getTesla")
            return request.data
        } catch (error) {
            throw error
        }
    }
)


